import React from 'react';

export function ProgressBar({ value, color = '#f97316', height = 4, showLabel = false }: {
  value: number; color?: string; height?: number; showLabel?: boolean;
}) {
  return (
    <div style={{ width: '100%' }}>
      {showLabel && (
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4, fontSize: 11, fontFamily: 'JetBrains Mono, monospace', color: '#6b6880' }}>
          <span>Progreso</span><span style={{ color }}>{value}%</span>
        </div>
      )}
      <div style={{ width: '100%', height, background: '#27262f', borderRadius: height }}>
        <div style={{ height: '100%', width: `${Math.min(value, 100)}%`, background: `linear-gradient(90deg, ${color}, ${color}cc)`, borderRadius: height, transition: 'width 0.6s cubic-bezier(0.16,1,0.3,1)', boxShadow: value > 0 ? `0 0 8px ${color}66` : 'none' }} />
      </div>
    </div>
  );
}
